import React from "react";
import classes from "./PagesTitleCol.module.css";

interface Props {
  title: string;
  description: string;
  bg_imageName: string;
}

// Maps a bg_imageName to its CSS module variant. Anything not listed here
// (including a typo or a future page that forgets to add a case) now falls
// back to `.default` instead of silently rendering an unstyled, imageless
// div — which is what happened before with the missing `.container` class.
const BANNER_VARIANTS: Record<string, string> = {
  contact: classes.contact,
  about: classes.about,
  blog: classes.blog,
  rider: classes.rider,
  privacy: classes.privacy,
  terms: classes.terms,
};

const PagesTitleCol: React.FC<Props> = ({ description, title, bg_imageName }) => {
  const bannerClass = BANNER_VARIANTS[bg_imageName] || classes.default;

  return (
    <div className={bannerClass}>
      <div className={classes.wrapper}>
        <div className={classes.inner}>
          <p className={classes.eyebrow}>{title}</p>
          <h1>{description}</h1>
        </div>
      </div>
    </div>
  );
};

export default PagesTitleCol;